module.exports = __webpack_public_path__ + "img/banner_about.7cd0ef60.png";